module.exports = __webpack_public_path__ + "img/banner_arrow.57fece8f.svg";